/* ExerciseWindowConfigurationService / MaturityScheduleConfigurationService not available in production api-services build
import type { ExternalTableSchema } from '@packages/table-builder';

export const exercisabilityTierConfigTable: ExternalTableSchema = {
  metadata: {
    title: 'Maturity Schedule Configuration',
    entity: 'MaturitySchedule',
  },

  dataSource: {
    endpoint:
      '/api/award-settlement/api/app/maturity-schedule-configuration/maturity-schedule-configuration-list',
    method: 'GET',
    rowIdField: 'id',
  },

  columns: [
    {
      field: 'name',
      header: 'Name',
      type: 'text',
      width: 250,
      sortable: true,
    },
    {
      field: 'isEnabled',
      header: 'Enabled',
      type: 'badge',
      width: 100,
      align: 'center',
      sortable: true,
      conditionalValues: { true: 'Yes', false: 'No' },
      badge: { statusMap: { true: 'success', false: 'error' }, defaultVariant: 'error' },
    },
    {
      field: 'stepCount',
      header: 'Steps',
      type: 'number',
      width: 100,
      align: 'center',
      sortable: false,
    },
    {
      field: 'createdDate',
      header: 'Created',
      type: 'date',
      width: 130,
      sortable: true,
    },
  ],

  actions: {
    toolbar: {
      primary: { id: 'ADD_EXERCISABILITY_TIER_CONFIG', label: 'Add Configuration' },
    },
    row: [
      { id: 'VIEW_EXERCISABILITY_TIER_CONFIG', label: 'View' },
      { id: 'EDIT_EXERCISABILITY_TIER_CONFIG', label: 'Edit' },
      { id: 'DELETE_EXERCISABILITY_TIER_CONFIG', label: 'Delete', variant: 'danger' },
    ],
  },

  features: {
    search: { enabled: true, placeholder: 'Search by name' },
    pagination: { mode: 'pagination', defaultSize: 10 },
    defaultSort: { field: 'createdDate', direction: 'desc' },
  },
};
*/
